import _slicedToArray from "/builds/M9cfiv79/0/everlywell/apps/www/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import React, { useState } from "react";
import * as S from "./styles";
import OrderEmptyView from "./OrderEmptyView";
import OrderItem from "./OrderItem";
import OrderSummaryRow from "./OrderSummaryRow";
import { OrderDisclaimer } from "./OrderDisclaimer";
import { calculateProductsSubtotal, formatPrice } from "./helpers";
export function OrderSummary(_ref) {
  var e = _ref.products,
      r = _ref.shippingMethod,
      _ref$isDisabled = _ref.isDisabled,
      t = _ref$isDisabled === void 0 ? !0 : _ref$isDisabled,
      a = _ref.onClick,
      i = _ref.disclaimersList;
  void 0 === e && (e = []);

  var l = 0 === e.length,
      m = calculateProductsSubtotal(e),
      c = formatPrice(m),
      o = parseFloat((null == r ? void 0 : r.price) || "0"),
      n = formatPrice(m + o),
      _useState = useState(!1),
      _useState2 = _slicedToArray(_useState, 2),
      d = _useState2[0],
      p = _useState2[1];

  return React.createElement(React.Fragment, null, React.createElement(S.OrderContainer, null, React.createElement(S.OrderItemsContainer, null, l ? React.createElement(OrderEmptyView, null) : e.map(function (e, r) {
    return React.createElement(OrderItem, {
      key: r,
      product: e
    });
  })), React.createElement(S.PricingContainer, null, React.createElement(OrderSummaryRow, {
    id: "subtotal",
    label: "Subtotal",
    price: c
  }), React.createElement(OrderSummaryRow, {
    id: "shipping",
    label: "Shipping",
    price: o
  }), React.createElement(S.PricingDivider, null), React.createElement(OrderSummaryRow, {
    id: "total",
    label: "Grand Total",
    price: n,
    isTotal: !0
  }), React.createElement(S.OrderButton, {
    appearance: "primary",
    onClick: function onClick(e) {
      p(!0), a && a(e);
    },
    isDisabled: t,
    isLoading: d
  }, "Place Order"))), i && i.length > 0 && i.map(function (e, r) {
    return React.createElement(OrderDisclaimer, {
      key: r.toString(),
      highlighted: e.highlighted,
      children: e.component
    });
  }));
}
export default OrderSummary;